module.exports = __webpack_public_path__ + "assets/img/enterIcon6.3998cd1f.png";